export function parseJsonObject(raw) {
  if (typeof raw !== 'string' || raw.trim() === '') return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
}

export function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function buildCanonicalQuery(values = {}) {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (!key.startsWith('filter_') && !key.startsWith('query_type_')) return;
    const normalized = typeof value === 'string' ? value.trim() : '';
    if (!normalized) return;
    params.set(key, normalized);
  });
  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
}

export function parseCanonicalFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  const canonical = {};
  params.forEach((value, key) => {
    if (key.startsWith('filter_') || key.startsWith('query_type_')) canonical[key] = value;
  });
  return canonical;
}

export function buildCatalogUrl(canonicalValues = {}, config = {}) {
  const query = buildCanonicalQuery(canonicalValues);
  const configuredBase = typeof config.catalogUrl === 'string' ? config.catalogUrl.trim() : '';
  const base = configuredBase || `${window.location.origin}/productos/`;
  const url = new URL(base, window.location.origin);
  if (query) url.search = query.substring(1);
  return url.toString();
}

export function navigateTo(url) {
  if (window.top && window.top.location) {
    window.top.location.href = url;
    return;
  }
  window.location.href = url;
}

export function t(key, fallback = '') {
  const source = (typeof window !== 'undefined' && window.wgfI18n && typeof window.wgfI18n === 'object')
    ? window.wgfI18n
    : {};
  const value = source[key];
  return typeof value === 'string' && value.trim() ? value : fallback;
}

export function wgfWarn(message, details = null) {
  if (typeof console === 'undefined' || typeof console.warn !== 'function') return;
  if (details !== null && typeof details !== 'undefined') {
    console.warn(`[WGF] ${message}`, details);
    return;
  }
  console.warn(`[WGF] ${message}`);
}

export function ensureString(value, fallback = '') {
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
}

export function ensureObject(value, fallback = {}) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : fallback;
}

export function normalizeCalculatorConfig(rawConfig = {}) {
  const config = ensureObject(rawConfig, {});
  const normalizedContext = ensureString(config.context, 'inline');
  const context = ['inline', 'popup'].includes(normalizedContext) ? normalizedContext : 'inline';
  const catalogUrl = ensureString(config.catalogUrl, `${window.location.origin}/productos/`);

  if (!Array.isArray(config.calculatorSteps)) {
    wgfWarn('Missing or invalid calculatorSteps; using defaults.');
  }

  if (!ensureObject(config.calculatorMapping, null)) {
    wgfWarn('Missing or invalid calculatorMapping; using defaults.');
  }

  if (!ensureObject(config.calculatorOptions, null)) {
    wgfWarn('Missing or invalid calculatorOptions; using empty options.');
  }

  return {
    ...config,
    context,
    catalogUrl,
    calculatorSteps: Array.isArray(config.calculatorSteps) ? config.calculatorSteps : [],
    calculatorMapping: ensureObject(config.calculatorMapping, {}),
    calculatorOptions: ensureObject(config.calculatorOptions, {}),
  };
}
